import type { PropsWithChildren } from 'react';
import { cn } from 'utils/tailwind';

type ContainerLayoutProps = {
  className?: string;
  noXPadding?: boolean;
  noYPadding?: boolean;
  noBottomPadding?: boolean;
  id?: string;
};

export const ContainerLayout = ({
  children,
  className,
  noXPadding,
  noYPadding,
  noBottomPadding,
  id,
}: PropsWithChildren<ContainerLayoutProps>) => (
  <div
    id={id}
    className={cn('p-6 md:p-8', className, {
      'px-0 md:p-0': noXPadding,
      'py-0 md:py-0': noYPadding,
      'pb-0 md:pb-0': noBottomPadding,
    })}
  >
    {children}
  </div>
);
